import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that handles scroll behavior when routes change.
 * - If URL has a hash (#section), scrolls to that element
 * - Otherwise scrolls to top of page
 */
const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();
  
  useEffect(() => {
    // If there's a hash, scroll to that element
    if (hash) {
      const elementId = hash.replace('#', '');
      
      const scrollToElement = () => {
        const element = document.getElementById(elementId);
        
        if (element) {
          const headerHeight = document.querySelector('header')?.offsetHeight || 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          return true;
        }
        return false;
      };
      
      // Try immediately
      if (!scrollToElement()) {
        // Retry after short delay (for fast renders)
        setTimeout(() => {
          if (!scrollToElement()) {
            // Retry after longer delay (for slower renders/images)
            setTimeout(() => {
              if (!scrollToElement()) {
                // Final attempt after even longer delay
                setTimeout(scrollToElement, 800);
              }
            }, 400);
          }
        }, 150);
      }
    } else {
      // No hash - scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [pathname, hash]);
  
  // This component doesn't render anything
  return null;
};

export default ScrollToTop;
